<template>
	<el-card class="guest-container">
		<template #header>
			<div class="header">
				<Search v-on:inputValue="inputValue" />
			</div>
		</template>
		<el-table v-loading="loading" ref="multipleTable" :data="list.data" tooltip-effect="dark" style="width: 100%">
			<el-table-column prop="email" label="邮箱"></el-table-column>
			<el-table-column label="姓名">
				<template v-slot="scope">
					{{scope.row.last_name}}&nbsp;{{scope.row.first_name}}
				</template>
			</el-table-column>
			<el-table-column label="获得积分">
				<template v-slot="scope">
					{{scope.row.customer_point.reward_points}}
				</template>
			</el-table-column>
			<el-table-column label="使用积分">
				<template v-slot="scope">
					{{scope.row.customer_point.use_points}}
				</template>
			</el-table-column>
			<el-table-column label="操作" width="auto" align="center">
				<template #default="scope">
					<el-button type="primary" size="mini" @click="operation(scope.row)">操作</el-button>
				</template>
			</el-table-column>
		</el-table>
		<pages :total="total" :page-size="pageSize" @handleSizeChangeSub="handleSizeChangeFun" @handleCurrentChangeSub="handleCurrentChangeFun"></pages>
	</el-card>
	<el-dialog title="积分管理" v-model="dialogFormVisible">
		<el-form :model="form" ref="form">
			<el-form-item>
				<el-row :gutter="20">
					<el-col :span="2">
						<label>类别</label>
					</el-col>
					<el-col :span="10" style="width: 28%">
						<el-form-item :rules="rules.variable_points_action" prop="variable_points_action">
							<el-select v-model="form.variable_points_action" clearable placeholder="请选择" style="display: block">
								<el-option label="送积分" value="1">
								</el-option>
								<el-option label="扣积分" value="2">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item :rules="rules.points" prop="points">
							<el-input placeholder="请输入内容" v-model="form.points" clearable>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form-item>
		</el-form>
		<template #footer>
		  <span class="dialog-footer">
		    <el-button @click="dialogFormVisible = false">取 消</el-button>
		    <el-button type="primary"  @click="submit()">确 定</el-button>
		  </span>
		</template>
	</el-dialog>
</template>

<script>
	import pages from '../common/Pagination.vue'
	import Search from '../common/Search.vue'
	export default {
		name: 'customer_point',
		components: {
			Search,
			pages
		},
		data() {
			return {
				total: 0,
				currentPage: 1,
				pageSize: 10,
				list: [],
				tableData:[],
				loading: false,
				dialogFormVisible: false,
				formLabelWidth: '120px',
				form: {
					id:'',
					variable_points_action:'',
					points:'',
				},
				rules: {
					variable_points_action: [{
						required: true,
						message: '请选择类别',
						trigger: 'change'
					}],
					points: [{
						required: true,
						message: '请填写内容',
						trigger: 'blur'
					}],
				},
			}
		},
		methods: {
			handleSizeChangeFun(page) {
				this.pageSize = page;
				this.getCustomer();
			},
			handleCurrentChangeFun(page) {
				this.currentPage = page;
				let str = '';
				str = this.$route.path + '?p=' + page;
				this.$router.push(str);
				this.getCustomer();
			},
			getCustomer() {
				let page = '';
				this.loading = true;
				this.httpPost({
					url: '/admin/customer/customer_list',
					data: {
						p: this.currentPage,
						routePath: this.$route.path
					},
				}).then((res) => {
					this.list = res.data;
					this.total = res.data.total;
					this.currentPage = res.data.currentPage;
					this.loading = false;
				})
			},
			inputValue(inpVal) {
				this.loading = true;
				this.httpPost({
					url: '/admin/customer/customer_list',
					data:{
						keywords: inpVal
					}
				}).then((res) => {
					this.list = res.data;
					this.total = res.data.total;
					this.currentPage = res.data.currentPage;
					this.loading = false;
				})

			},
			operation(val) {
				this.form={};
				this.form.id = val.id;
				this.dialogFormVisible = true;
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			submit(){
				this.$refs['form'].validate((valid)=>{
					if(valid){
						this.updateCustomerPoint();
					}else{
						console.log('error submit!')
						return false;
					}
				})
			},
			updateCustomerPoint(){
				this.dialogFormVisible=false;
				this.loading=true;
				this.httpPost({
					url:'/admin/customer/change_point',
					data:this.form,
				}).then((res)=>{
					if(res.code ==1){
						this.$message.success(res.msg);
						this.getCustomer();
					}
				})
			}
		},
		created() {
			this.getCustomer();
		}
	}
</script>

<style>
</style>
